module.exports = __webpack_public_path__ + "static/media/carousel-02.f12fc87e.png";